import LocationsTable from "./locations-table";

export default LocationsTable;